var messages = require("./ms-MY/messages.json");
export default messages;